import script from "./send-offers-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./send-offers-modal.vue?vue&type=script&setup=true&lang=ts"

import "./send-offers-modal.vue?vue&type=style&index=0&id=be56e12c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be56e12c"]])

export default __exports__